module.exports = __webpack_public_path__ + "icon-inst.a33a799195aebed6c135.png";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/ucla-prrla/ucla-prrla/ucla-prrla/src/assets/img/icon-inst.png
// module id = ../../../../../src/assets/img/icon-inst.png
// module chunks = 2